export const NO_CATEGORY = 'no_category';
